<template>
  <div>
    <el-card>

      <div v-if="showUploadPercentage" class="progress">
        <el-progress :percentage="uploadPercentage"></el-progress>
      </div>
      <form class="loading"
            :class="{
              'is-dragover': dragover
            }"
            @drop.prevent="onDrop"
            @dragover.prevent="onDragover"
            @dragleave.prevent="dragover = false">
        <label for="file" class="loading__label">
          <i class="el-icon-upload"></i>
          {{$t('project_tab_files_first_title')}}
        </label>
        <input ref='file' v-show="false" @change="handleFile" id="file" name="myFile" type="file">
      </form>

      <el-table
        :data="data"
        style="width: 100%; margin-top: 20px;"
        :empty-text="$t('general_noData')"
        size="mini"
        border>
        <el-table-column
          header-align="center"
          align="center"
          label="View"
          width="70">
          <template slot-scope="scope">
            <el-button @click="viewFile(scope.row.url, scope.row, -1, false)" size="mini" slot="reference" icon="el-icon-view"></el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="Date Uploaded"
          width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.date }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="Allocated To">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.entityTypeId"
              placeholder="Type"
              filterable
              style="width: 100%;"
              @change="selectEntityType(scope)">
              <el-option v-for="item in entityTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="BU">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.buId"
              :disabled="!scope.row.entityTypeId"
              placeholder="BU"
              filterable
              style="width: 100%;"
              @change="selectBU(scope)">
              <el-option v-for="item in scope.row.buList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="WHS-ENG-PRO">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.entityTypeId !== 2"
              v-model="scope.row.parentId"
              :disabled="!scope.row.buId"
              placeholder="WHS-ENG-PRO"
              filterable
              style="width: 100%;"
              @change="selectParent(scope)">
              <el-option v-for="item in scope.row.parentList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="Task">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.taskId"
              :disabled="!scope.row.taskList.length"
              placeholder="Task"
              filterable
              style="width: 100%;"
              @change="selectTask(scope)">
              <el-option v-for="item in scope.row.taskList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="EU">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.userId"
              :disabled="!scope.row.taskId"
              placeholder="EU"
              filterable
              style="width: 100%;"
              @change="selectEU(scope)">
              <el-option v-for="item in scope.row.userList"
                :key="item.userId"
                :label="item.userFullName"
                :value="item.userId">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="Vendor">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.vendorId"
              :disabled="!scope.row.userId"
              placeholder="Select"
              filterable
              style="width: 100%;">
              <el-option v-for="item in scope.row.vendorList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="Action"
          width="160">
          <template slot-scope="scope">
            <el-button :disabled="!scope.row.vendorId" @click="addItem(scope.row)" type="primary" size="mini">Add</el-button>
            <el-button @click="deleteItem(scope.row)" type="danger" size="mini">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div v-if="viewerType == 2">
      <div v-show="false" class="images" v-viewer="getViewerSettings">
        <img :src="fileUrl" :key="fileUrl" />
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { viewEditFileMixin } from '../../../mixins/viewEditFileMixin'
  import axios from 'axios'

  export default {
    name: 'Unallocated',
    mixins: [viewEditFileMixin],
    data() {
      return {
        data: [],

        showUploadPercentage: false,
        uploadPercentage: 0,
        dragover: false,

        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse', disabled: true },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
      }
    },
    computed: {
      ...mapGetters([
        'getViewerSettings'
      ]),
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    methods: {
      openTab() {
        this.getData()
      },
      getData() {
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios
          .get(`/api/v1/source-document?companyId=${this.$route.query.companyId}&created=false`)
          .then(response => {
            loader.hide()
            let data = response.data.result.reverse()
            data.forEach(item => {
              item.entityTypeId = null
              item.buList = []
              item.buId = null
              item.parentList = []
              item.parentId = null
              item.taskList = []
              item.taskId = null
              item.userList = []
              item.userId = null
              item.vendorList = []
              item.vendorId = null
            })

            this.data = data
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error)
          });
      },
      onDragover() {
        this.dragover = true
      },
      async onDrop(e) {
        const file = e.dataTransfer.files[0]

        const formData = new FormData()
        formData.append('file', file)

        const config = {
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
          }
        };

        formData.append('convert', false)
        formData.append('entityId', this.$route.query.companyId)
        formData.append('entityTypeId', 80)
        formData.append('oldParentId', null)
        formData.append('taskId', null)
        formData.append('historyEntityId', 0)
        let loader = this.$loading.show()
        this.showUploadPercentage = true

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
            this.$notify({ title: "Success", message: "File upload", type: "success" })
            this.getData()
            this.resetInputs()
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
            this.dragover = false
          })
          .catch(error => {
            console.log('An error occurred:', error)
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
            this.dragover = false
          });
      },
      async handleFile(e) {
        const file = e.target.files[0]

        const formData = new FormData()
        formData.append('file', file)

        const config = {
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
          }
        };

        formData.append('convert', false)
        formData.append('entityId', this.$route.query.companyId)
        formData.append('entityTypeId', 80)
        formData.append('oldParentId', null)
        formData.append('taskId', null)
        formData.append('historyEntityId', 0)
        let loader = this.$loading.show()
        this.showUploadPercentage = true

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
            this.$notify({ title: "Success", message: "File upload", type: "success" })
            this.getData()
            this.resetInputs()
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          })
          .catch(error => {
            console.log('An error occurred:', error)
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          });
      },
      resetInputs() {
        if (this.$refs.file) this.$refs.file.value = null
      },
      async selectEntityType(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.buList = []
          scope.row.buId = null
          scope.row.parentList = []
          scope.row.parentId = null
          scope.row.taskList = []
          scope.row.taskId = null
          scope.row.userList = []
          scope.row.userId = null
          scope.row.vendorList = []
          scope.row.vendorId = null

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();

          const response = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
          scope.row.buList = response.data.list

          loader.hide()
        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      async selectBU(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.parentList = []
          scope.row.parentId = null
          scope.row.taskList = []
          scope.row.taskId = null
          scope.row.userList = []
          scope.row.userId = null
          scope.row.vendorList = []
          scope.row.vendorId = null

          switch (scope.row.entityTypeId) {
            case 1:
              axios.get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${scope.row.buId}`).then(response => {
                console.log('---', response.data)
                scope.row.parentList = response.data.list
              }).catch(err => {
                console.log(err)
              })
              break;
            case 2:
              axios.post(`/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}`).then(response => {
                console.log('---', response.data)
                const list = response.data.newList
                list.shift()
                scope.row.taskList = list
                scope.row.parentId = scope.row.buId
              }).catch(err => {
                console.log(err)
              })
              break;
            case 3:
              axios.get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${scope.row.buId}`).then(response => {
                console.log('---', response.data)
                scope.row.parentList = response.data.list
              }).catch(err => {
                console.log(err)
              })
              break
          }

          loader.hide()
        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      async selectParent(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.taskList = []
          scope.row.taskId = null
          scope.row.userList = []
          scope.row.userId = null
          scope.row.vendorList = []
          scope.row.vendorId = null

          let url = ''
          switch (scope.row.entityTypeId) {
            case  1:
              url = `/api/v1/projectTasks/list?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}`
              break;
            case 2:
              url = `/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.parentId}`
              break;
            case 3:
              url = `/api/v1/engagementTasks/list?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}`
              break
          }

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(url)
          loader.hide()
          const list = data.newList ? data.newList : data.newlist
          list.shift()
          scope.row.taskList = list

        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      async selectTask(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.userList = []
          scope.row.userId = null
          scope.row.vendorList = []
          scope.row.vendorId = null

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          switch (scope.row.entityTypeId) {
            case 1:
              axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}&projectTaskId=${scope.row.taskId}`).then(response => {
                scope.row.userList = response.data.extendedInfo.projectTaskCompanyUserList
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 2:
              axios.post(`/api/v1/businessUnitTasks/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}&businessUnitTaskId=${scope.row.taskId}`).then(response => {
                scope.row.userList = response.data.extendedInfo.businessUnitTaskCompanyUserList
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 3:
              axios.post(`/api/v1/engagementTasks/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}&engagementTaskId=${scope.row.taskId}`).then(response => {
                scope.row.userList = response.data.extendedInfo.engagementTaskCompanyUserList
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
          }

        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      async selectEU(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.vendorList = []
          scope.row.vendorId = null

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/client-vendor/list?type=vendor&companyId=${this.$route.query.companyId}&currencyId=${this.companyLayout.currency.id}`).then(response => {
              scope.row.vendorList = response.data.list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })

        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      addItem(row) {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/source-document`, {
          companyId: this.$route.query.companyId,
          fileUrl: row.url,
          uploadedFileDate: row.date,
          buId: row.buId,
          entityTypeId: row.entityTypeId,
          parentId: row.parentId,
          taskId: row.taskId,
          userId: row.userId,
          vendorId: row.vendorId
        }).then(response => {
            this.getData()
            this.$notify({ title: "Success", message: "Add", type: "success" })
            loader.hide()
          }).catch(err => {
            console.log(err)
            loader.hide()
          })
      },
      async deleteItem(row) {
        // try {
        //   await axios.delete(`/api/v1/source-document?id=${row.id}`)
        //   this.getData()
        // } catch (error) {
        //   console.log('error', error)
        // }

        this.$confirm(this.$t('file_thisWillPermanentlyDeleteTheFileContinue'), this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${row.id}&entityId=${this.$route.query.companyId}&entityTypeId=80&deleteChild=false&taskId=null&historyEntityId=0`)
              .then(response => {
                this.getData()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  &__label {
    width: 100%;
    height: 170px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    z-index: 0;

    &:hover {
      border-color: #409EFF;
    }
    .el-icon-upload {
      display: block;
      font-size: 67px;
      color: #C0C4CC;
      margin: 40px 0 16px;
      line-height: 50px;
    }
    span {
      color: #409EFF;
    }
  }
  &.is-dragover{
    border: 1px dashed #409EFF;
    border-radius: 6px;
    .loading__label{
      background-color:rgba(32,159,255,.06);
    }
  }
}
</style>